import React from 'react'
import { Space, Button } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import ProfileIcon from '../ProfileIcon'
import DropDownNotification from '../DropDownNotification'
import CourseNavigation from '../CourseNavigation'
import styled from 'styled-components'

const FlexedDiv = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  min-height: 56px;
  background: hsl(33, 100%, 50%);
  @media (min-width: 768px) {
    padding: 0 32px;
  }
`

const AppHeader = ({ courseNavigation, isMobile, onMenuClick }) => {
  return (
    <FlexedDiv>
      <Space size="middle">
        {isMobile && (
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: 20, color: '#fff' }} />}
            onClick={onMenuClick}
            style={{ minWidth: 44, minHeight: 44, padding: 0 }}
          />
        )}
        {courseNavigation && <CourseNavigation isMobile={isMobile} />}
      </Space>
      <Space size="small">
        <DropDownNotification />
        <ProfileIcon />
      </Space>
    </FlexedDiv>
  )
}

export default AppHeader
